import React, { FC, Fragment, useContext } from "react";
import { UserContext } from "contexts/UserContext/UserContext";

export const Authenticated: FC<React.PropsWithChildren> = ({ children }) => {
  const { isLoggedIn } = useContext(UserContext);

  if (!isLoggedIn) {
    return null;
  }

  return <>{children}</>;
};

export const NotAuthenticated: FC<React.PropsWithChildren> = ({ children }) => {
  const { isLoggedIn } = useContext(UserContext);

  if (isLoggedIn) {
    return null;
  }

  return <>{children}</>;
};
